export default __webpack_public_path__ + "static/media/sports09.530daab5.jpg";